(function () {
    'use strict';

    function ServiceItemPickerComponentController($scope, $state, PersonInfoSearch, ParseLinks, AlertService, paginationConstants, translate, translatePartialLoader, SelectorData, SelectorDataQuery, ServiceItemCustom) {
        //
        var $ctrl = this;
        var pagingParams = {};
        $ctrl.loadPage = loadPage;
        $ctrl.noCache = false;
        $ctrl.servicesNames = [];
        $ctrl.querySearch = querySearch;
        // $ctrl.serviceItems = [];
        $ctrl.serviceItem_changed = serviceItem_changed;

        loadAll();
        loadPage();

        function loadAll() {

            loadAllServiceItems();

            function onSuccess(data, headers) {

            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            translatePartialLoader.addPart('serviceItem');
            translatePartialLoader.addPart('global');
            translatePartialLoader = translate.refresh();


        }

        function loadAllServiceItems() {

            if ($ctrl.servantId) {
                ServiceItemCustom.getServiceItemsByServantId($ctrl.servantId).query(function (items) {
                    $ctrl.serviceItems = items;
                });
            } else {
                ServiceItemCustom.getActiveServiceItemsByCurrentCompany().query(function (items) {
                    $ctrl.serviceItems = items;
                });
            }

        }

        function querySearch(query) {

            var temp = [];

            angular.forEach($ctrl.serviceItems, function (item) {
                if (item.itemTitle.indexOf(query) > -1) {
                    temp.push(item);
                } else if (query == null) {
                    temp = $ctrl.serviceItems;
                }
            })

            return temp;

        }

        function serviceItem_changed(item) {

        }


        $scope.$watch('$ctrl.servantId', function () {

            if ($ctrl.servantId) {
                loadAllServiceItems();
            }
        })
        $scope.$watch('$ctrl.selectedService', function () {

            if (!$ctrl.selectedService && $ctrl.searchText) {
                $ctrl.searchText = '';
            }
        })

    }

    var ServiceItemPickerComponent = {
        // template:'tets:{{$ctrl.testStr}}',
        templateUrl: 'app/components/partial-forms/service-item-picker/partial-form.service-item-picker.html',
        controller: ServiceItemPickerComponentController,
        bindings:
            {
                isDisabled: '=',
                selectedService: "=",
                servantId: "=",
                onServiceChanged: "&"
            }

    };

    angular
        .module('tikonApp')
        .component('pfServiceItemPicker', ServiceItemPickerComponent)

    ServiceItemPickerComponentController.$inject = ['$scope', '$state', 'PersonInfoSearch', 'ParseLinks', 'AlertService', 'paginationConstants', '$translate', '$translatePartialLoader', 'SelectorData', 'SelectorDataQuery', 'ServiceItemCustom'];


})();

